export { AoFooterComponent } from './ao-footer/ao-footer.component';
export * from './shared-ao-components.module';
